var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import { Switch, Route } from "react-router-dom";

import { LayoutAdmin, LayoutDashboard, LayoutInbox } from '../';
import { getMenuByUrl, getParents, getResultsById, getInboxMenu, filterInboxResults } from "../../resources/functions/";

var ExampleInboxApp = (_temp2 = _class = function (_Component) {
    _inherits(ExampleInboxApp, _Component);

    function ExampleInboxApp() {
        var _temp, _this, _ret;

        _classCallCheck(this, ExampleInboxApp);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
            root: undefined,
            pathname: undefined,
            moduleSize: "large",
            menu: [],
            menuByUrl: {},
            parents: [],
            results: [],
            resultsById: {},
            uniqueId: undefined,
            item: undefined
        }, _this.componentDidUpdate = function (prevProps, prevState) {

            if (prevProps.app !== _this.props.app) {
                _this.getApp();
            }

            if (prevProps.data !== _this.props.data) {
                _this.getData();
            }

            if (prevProps.location.pathname !== _this.props.location.pathname) {
                _this.getPathname();
            }

            if (prevState.uniqueId !== _this.state.uniqueId) {
                _this.getItem();
            }

            if (prevState.results !== _this.state.results) {
                _this.getCategories();
            }
        }, _this.getItem = function () {
            var _this$state = _this.state,
                uniqueId = _this$state.uniqueId,
                resultsById = _this$state.resultsById;


            var item = void 0;

            if (uniqueId && resultsById[uniqueId]) {
                item = resultsById[uniqueId];
            }

            _this.setState({
                item: item || undefined
            });
        }, _this.getData = function () {
            var data = _this.props.data;


            var results = data.models || [];
            var resultsById = getResultsById(results);

            _this.setState({
                results: results,
                resultsById: resultsById
            });
        }, _this.getCategories = function () {
            var _this$state2 = _this.state,
                root = _this$state2.root,
                results = _this$state2.results;


            var menu = getInboxMenu(root, results);

            _this.setState({
                menu: menu
            });
        }, _this.getApp = function () {
            var app = _this.props.app;
            var layout = _this.props.layout || _this.props.app.layout || undefined;
            var root = _this.props.root || _this.props.app.root || undefined;
            var menu = _this.props.menu || _this.props.app.menu || [];

            var menuByUrl = void 0,
                parents = void 0;

            if (menu) {
                menuByUrl = getMenuByUrl(root, menu);
                parents = getParents(menuByUrl, root);
            }

            _this.setState({
                root: root,
                pathname: root,
                app: app,
                layout: layout,
                menu: menu,
                menuByUrl: menuByUrl,
                parents: parents,
                urlPattern: root + "/section/category/:uniqueId"
            });
        }, _this.getPathname = function () {
            var _this$state3 = _this.state,
                root = _this$state3.root,
                menuByUrl = _this$state3.menuByUrl,
                results = _this$state3.results;
            var pathname = _this.props.location.pathname;


            var parents = getParents(menuByUrl, pathname);

            var url = pathname.slice(root.length);
            var urls = url.split('/');

            var section = urls[1] || undefined;
            var category = urls[2] || undefined;
            var uniqueId = urls[3] || undefined;

            var resultsByCategory = void 0;

            if (section) {
                resultsByCategory = filterInboxResults(results, section, category);
            }

            _this.setState({
                pathname: pathname,
                parents: parents,
                uniqueId: uniqueId,
                section: section,
                category: category,
                resultsByCategory: resultsByCategory
            });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    ExampleInboxApp.prototype.componentDidMount = function componentDidMount() {
        this.getApp();
        this.getData();
    };

    ExampleInboxApp.prototype.render = function render() {
        var _state = this.state,
            results = _state.results,
            resultsByCategory = _state.resultsByCategory;


        return React.createElement(
            LayoutAdmin,
            _extends({}, this.props, this.state),
            React.createElement(LayoutInbox, _extends({}, this.state, { results: resultsByCategory || results }))
        );
    };

    return ExampleInboxApp;
}(Component), _class.defaultProps = {
    app: undefined,
    user: undefined,
    owner: undefined,
    data: undefined
}, _temp2);


export default ExampleInboxApp;